import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  background-color: #ffffff;
  width: 100%;
  max-width: 660px;
  margin-bottom: 32px;
`;
const Title = styled.div`
  height: 47px;
  margin-left: 32px;
  margin-bottom: 14px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 47px;
  color: #03589c;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 22px;
      text-align: center;

      @media (max-width: ${breakpoints.mobileL}) {
        font-size: 18px;
        margin-left: 0px;
        margin-bottom: 0px;
        height: auto;
      }
    `}
`;
const InfoForm = styled.div`
  padding: 48px 52px 52px 48px;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      padding: 0 28px;
      box-shadow: none;

      @media (max-width: ${breakpoints.mobileM}) {
        padding: 8px 16px;
      }
    `}
`;
const Group = styled(Form.Group)`
  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;
const Label = styled(Form.Label)`
  height: 28px;
  margin-left: 8px;
  margin-bottom: 0;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 28px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
`;
const Control = styled(Form.Control)`
  font-family: "Montserrat";
  color: #394149;
  font-weight: 400;
  height: 38px;
  padding-right: 106px;

  &:read-only {
    background-color: inherit;
  }

  ${({ type }) =>
    type === "password" &&
    css`
      letter-spacing: 5px;
      font-size: 24px;
      font-weight: 700;
    `}

  @media (max-width: ${breakpoints.mobileM}) {
    font-size: 0.75rem;
    padding-right: 70px;
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const ChangeButton = styled.button`
  position: absolute;
  box-sizing: border-box;
  top: 0px;
  bottom: 0px;
  right: 12px;
  margin: auto 0px;
  padding: 0;
  border: none;
  background: transparent;
  color: #f37217;
  text-decoration: underline;
  font-size: 0.875rem;

  @media (max-width: ${breakpoints.mobileM}) {
    width: 56px;
    text-align: center;
    line-height: 1rem;
    font-size: 0.625rem;
  }
`;

function AccountInfo({ username, onLoginClick, onPasswordClick }) {
  return (
    <Container>
      <Title>Account Info</Title>
      <InfoForm>
        <Group>
          <Label>Login</Label>
          <InputContainer>
            <Control readOnly type="text" placeholder="Enter login" name="username" value={username || ""} />
            <ChangeButton onClick={onLoginClick}>Change login</ChangeButton>
          </InputContainer>
        </Group>

        <Group>
          <Label>Password</Label>
          <InputContainer>
            <Control readOnly type="password" placeholder="Enter password" name="password" value="password" />
            <ChangeButton onClick={onPasswordClick}>Change password</ChangeButton>
          </InputContainer>
        </Group>
      </InfoForm>
    </Container>
  );
}

AccountInfo.propTypes = {
  username: PropTypes.string,
  onLoginClick: PropTypes.func,
  onPasswordClick: PropTypes.func,
};

export default AccountInfo;
